<template>
  <!-- 无动画模式 -->
  <div v-if="!shouldEnableAnimation && visible" class="popup_wrap popup_wrap--no-animation" @contextmenu.prevent.stop="" ref="popup_wrap">
    <div class="popup_bg" @click="clickBg"></div>
      <div class="popup_cont">
        <div class="popup_minimize" @click="popupMinimize" v-if="isShowMinimize"><span class="iconfont">&#xe650;</span></div>
        <div  v-if="full" v-show="isShowBtn" class="popup_full" @click="popupFull" ref="popup_full">
          <span class="iconfont" v-if="tagFull">&#xe6e8;</span>
          <span class="iconfont" v-else>&#xe65d;</span>
        </div>
        <div v-show="isShowBtn" class="popup_close" @click="popupClose"><span class="iconfont icon-md-close"></span></div>
        <div class="popup_info" ref="popup_info" :class="{'full':tagFull}" :style="'width:'+width+'px;height:'+height+'px;'">
          <slot></slot>
        </div>
      </div>
  </div>
  
  <!-- 有动画模式 -->
  <transition v-else name="modal" appear>
    <div v-if="visible" class="popup_wrap popup_wrap--animated" @contextmenu.prevent.stop="" ref="popup_wrap">
      <div class="popup_bg" @click="clickBg"></div>
      <div class="popup_cont">
        <div class="popup_minimize" @click="popupMinimize" v-if="isShowBtn && isShowMinimize"><span class="iconfont">&#xe650;</span></div>
        <div v-if="full" v-show="isShowBtn" class="popup_full" @click="popupFull" ref="popup_full">
          <span class="iconfont" v-if="tagFull">&#xe6e8;</span>
          <span class="iconfont" v-else>&#xe65d;</span>
        </div>
        <div v-show="isShowBtn" class="popup_close" @click="popupClose"><span class="iconfont icon-md-close"></span></div>
        <div class="popup_info" ref="popup_info" :class="{'full':tagFull}" :style="'width:'+width+'px;height:'+height+'px;'">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { EventBus } from '@/utils/eventBus.js';

export default {
  name: 'GztModal',
  components: {},
  props: {
    width: {
      type: Number,
      default: 1200
    },
    height: {
      type: Number,
      default: 750
    },
    full: {
      type: Boolean,
      default: false
    },
    isOpenBig: {
      type: Boolean,
      default: false
    },
    screen: { //是否一开始全屏
      type: Boolean,
      default: false
    },
    bgclick: {
      type: Boolean,
      default: false
    },
    isShowBtn:{
      type: Boolean,
      default: true
    },
    enableAnimation: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    // 是否显示最小化按钮
    isShowMinimize: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      tagFull: false,
      isFromBottomMenu: false, // 是否从底部菜单打开
      globalAppAnimation: true, // 全局应用动画配置
    };
  },
  computed: {
    shouldEnableAnimation() {
      // 如果全局应用动画被禁用，则禁用动画
      if (!this.globalAppAnimation) {
        return false;
      }
      // 如果从底部菜单打开，则禁用动画
      if (this.isFromBottomMenu) {
        return false;
      }
      // 否则使用props中的enableAnimation值
      return this.enableAnimation;
    }
  },
  methods: {
    clickBg() { //点击背景关闭
      console.log('点击背景关闭')
      this.$emit('update:visible', false)
      // 判断是否是历史菜单
      if(localStorage.getItem("historyMenuState") === "true"){
        // 通过EventBus触发关闭所有弹窗事件
        EventBus.$emit('closeAllModals');
        localStorage.setItem("historyMenuState", false);
      }
    },
    popupClose() { //关闭弹窗
      this.$emit('update:visible', false)
      localStorage.setItem("historyMenuState",false)
      // 删除底部路由
      console.log("底部路由ID",localStorage.getItem('tcId'));

      if(this.isShowMinimize){
        this.$store.dispatch('removeHistoryMenu', localStorage.getItem('tcId'))
      }
    },
    popupMinimize(){
      // 触发最小化事件，让父组件决定是否处理
      this.$emit('minimize')
      this.$emit('update:visible', false)
      localStorage.setItem("historyMenuState",false)
    },
    popupFullClick() {
      this.$emit('clear:visible', true)
      localStorage.setItem("historyMenuState",false)
    },
    popupFullOnClick() {
      this.tagFull = true
    },
    popupFullOffClick() {
      this.tagFull = false
    },
    hideBtn(){
      this.isShowBtn = false
    },
    popupFull() {
      this.tagFull = !this.tagFull
      this.$emit('popupFull', this.tagFull)
    },
    // 读取全局应用动画配置
    loadGlobalAppAnimation() {
      if (localStorage.getItem('gzt_appAnimation') === 'false') {
        this.globalAppAnimation = false;
      } else {
        // 默认为开启
        this.globalAppAnimation = true;
      }
      console.log('Modal: 加载全局应用动画配置', this.globalAppAnimation);
    },
    // 响应全局应用动画配置变更
    onAppAnimationChanged(isEnabled) {
      this.globalAppAnimation = isEnabled;
      console.log('Modal: 全局应用动画配置已更新', isEnabled);
    }
  },
  created() {
    //this.params.room_set_id = this.$route.query.id
    this.tagFull = false
    
    // 读取全局应用动画配置
    this.loadGlobalAppAnimation();
    
    // 监听全局应用动画配置变更事件
    EventBus.$on('app-animation-changed', this.onAppAnimationChanged);
  },
  beforeDestroy() {
    // 清理EventBus监听器，防止内存泄漏
    EventBus.$off('app-animation-changed', this.onAppAnimationChanged);
  },
  watch: {
    visible(val) {
      if (val) {
        // 检查是否从底部菜单打开
        this.isFromBottomMenu = localStorage.getItem('gzt_fromBottomMenu') === 'true';
      }
      
      // 安全检查 $route 是否存在（动态创建的组件可能没有注入 Vue Router）
      const routeType = this.$route && this.$route.query ? this.$route.query.type : undefined
      console.log(routeType !== undefined && routeType !== null && routeType !== '')
      if (routeType !== undefined && routeType !== null && routeType !== '') {
        // this.$route.query.type 存在且不为空
        this.tagFull = true
        this.isShowBtn = false
        console.log('关闭按钮打开全屏')
        return
      }else {
        this.tagFull = false
        this.isShowBtn = true
        console.log('正常显示')

      }

      // 判断用户是否设置了工作台应用最大化
      console.log(localStorage.getItem('gzt_openFullScreen'))
      if(localStorage.getItem('gzt_openFullScreen') === 'true'){
        this.tagFull = true
      }else {
        this.tagFull = false
      }

      if (val) {
        if (this.screen) {
          this.tagFull = true
        }
      } else {

      }
    }
  }
}
</script>

<style scoped>
.popup_wrap {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  z-index: 1001;
}

.popup_bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .6);
  z-index: 100;
}

.popup_cont {
  position: relative;
  z-index: 101;
}

.popup_minimize{
  position: absolute;
  top: 15px;
  right: 85px;
  cursor: pointer;
  z-index: 100;
}

.popup_minimize .iconfont {
  display: inline-block;
  padding: 4px;
  width: 14px;
  height: 14px;
  font-size: 14px;
  color: #fff;
  background: #0091FF;
  border-radius: 50%;
}

.popup_close {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  z-index: 100;
}

.popup_close .iconfont {
  display: inline-block;
  padding: 4px;
  width: 14px;
  height: 14px;
  font-size: 14px;
  color: #fff;
  background: #ff7330;
  border-radius: 50%;
}

.popup_full {
  position: absolute;
  top: 15px;
  right: 50px;
  cursor: pointer;
  z-index: 100;
}

.popup_full .iconfont {
  display: inline-block;
  padding: 4px;
  width: 14px;
  height: 14px;
  font-size: 14px;
  color: #fff;
  background: #34c759;
  border-radius: 50%;
}

.popup_info {
  position: relative;
  max-width: calc(100vw - 40px);
  max-height: calc(100vh - 20px);
  background: #fff;
  box-shadow: 0px 16px 24px -14px #0000003b;
  border-radius: 12px;
  box-sizing: border-box;
  overflow: hidden;
}

.popup_info.full {
  width: 100vw !important;
  height: 100vh !important;
  max-width: 100vw;
  max-height: 100vh;
  border-radius: 0px;
}

/* ========== 弹窗动画效果 ========== */

/* 弹窗整体进入动画 */
.modal-enter-active {
  transition: all 0.4s ease-out;
}

/* 弹窗整体离开动画 */
.modal-leave-active {
  transition: all 0.3s ease-in;
}

/* 弹窗整体进入/离开的透明度状态 */
.modal-enter,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-to,
.modal-leave {
  opacity: 1;
}

/* 背景遮罩渐显渐隐动画 - 只在有动画的弹窗上生效 */
.popup_wrap--animated .popup_bg {
  transition: opacity 0.3s ease;
}

.popup_wrap--animated .popup_minimize{
  transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}

/* 弹窗内容缩放和位移动画 - 只在有动画的弹窗上生效 */
.popup_wrap--animated .popup_cont {
  transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
  transform-origin: center center;
}

/* 全屏模式的过渡效果 - 只在有动画的弹窗上生效 */
.popup_wrap--animated .popup_info.full {
  transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}

/* 无动画模式的样式重置 */
.popup_wrap--no-animation .popup_bg,
.popup_wrap--no-animation .popup_cont,
.popup_wrap--no-animation .popup_info {
  transition: none !important;
  transform: none !important;
  opacity: 1 !important;
}

/* 只在transition进入期间应用的样式 */
.modal-enter .popup_bg {
  opacity: 0;
}

.modal-enter .popup_cont {
  opacity: 0;
  transform: scale(0.6) translateY(-30px);
}

.modal-enter .popup_info.full {
  transform: scale(0.92);
}

/* 只在transition离开期间应用的样式 */
.modal-leave-to .popup_bg {
  opacity: 0;
}

.modal-leave-to .popup_cont {
  opacity: 0;
  transform: scale(0.85) translateY(20px);
}

.modal-leave-to .popup_info.full {
  transform: scale(0.96);
}

/* 控制按钮延迟炫酷进入动画 */
.modal-enter-active .popup_close,
.modal-enter-active .popup_full {
  animation: buttonsFadeIn 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55) 0.2s both;
}

@keyframes buttonsFadeIn {
  0% {
    opacity: 0;
    transform: scale(0.3) rotate(-270deg);
  }
  60% {
    opacity: 1;
    transform: scale(1.1) rotate(10deg);
  }
  100% {
    opacity: 1;
    transform: scale(1) rotate(0deg);
  }
}

</style>
